import OperateRecord from './operate_record.vue'

export default {
    path: 'operateRecord',
    component: OperateRecord
}
